// @flow
import React from 'react'
import styled from 'styled-components'

const Component = styled.div`
  display: flex;

  input,
  select,
  .SingleDatePickerInput {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    -webkit-appearance: none;
  }
`

const InputGroup = ({
  children,
  style
}: {
  children?: any,
  style?: Object
}) => <Component style={style}>{children}</Component>

export default InputGroup



// WEBPACK FOOTER //
// ./src/components/InputGroup/index.js